import { BaseSerializer } from './base.serializer'
import { Briefing } from 'models'
import { HubCourseTimetableSerializer } from './hub-course-timetable.serializer'

export class BriefingSerializer extends BaseSerializer<Briefing> {
  static SERIALIZABLE_ATTRIBUTES = [
    'id', 'cityId', 'comment', 'name', 'address', 'timetable',
    'registrationCreatedSmsId', 'registrationCanceledSmsId', 'registrationReminderSmsId',
    'remindInMinutes', 'cityUtcOffset', 'mkkInspectionMode', 'mkkRegion', 'excludes'
  ]
  static SERIALIZERS = {
    timetable: HubCourseTimetableSerializer
  }
  static SERIALIZE_RENAME_KEYS = {
    timetable: 'timetableAttributes'
  }

  static DESERIALIZERS = {
    timetable: HubCourseTimetableSerializer
  }
  static DESERIALIZE_RENAME_KEYS = {}

  static initializeObject(attributes: Object): Briefing {
    return new Briefing(attributes)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/briefing.serializer.ts